import {
    Slide,
    ToastContainer,
    toast,
    type ToastContentProps,
  } from "react-toastify";
  import React from "react";
  import "./Toaster.scss"
import type { ToasterType } from "./types/Toaster.types";
  
  const Toaster: React.FC = () => {
    return (
      <ToastContainer
        pauseOnHover
        hideProgressBar
        closeButton={false}
        limit={1}
        transition={Slide}
      />
    );
  };
  
  export const showToast = (message: string, type: ToasterType) => {

    const getToastIcon = (type: ToasterType) => {
      if (type === "success") {
        return <div className="ic-success" />;
      } else if (type === "error") {
        return <div className="ic-error" />;
      } else if (type === "warning") {
        return <div className="ic-warning" />;
      } else {
        return <></>;
      }
    }

    toast(
      ({ closeToast }: ToastContentProps) => (
        <div className="toaster">
          <div className="toaster-content">
            {getToastIcon(type)}
            <div className="toast-message">{message}</div>
          </div>
          <button className="ic-close not-a-button" onClick={closeToast}></button>
        </div>
      ),
      {
        type,
        icon: false,
        autoClose: type === 'info' ? false : 2000
      }
    );
  };
  
  export default Toaster;
  
  